import { useMutation } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface CreateCapabilityProfileData {
  title: string;
  tags?: string;
  description?: string;
  documentation?: string;
  offerInCapabilityStore?: boolean;
  exemplaryInput?: string;
  exemplaryOutput?: string;
  exemplaryConfiguration?: string;
  inputSchema?: string;
  outputSchema?: string;
  vaultSchemas?: {
    uuid: string;
    container: string;
    label?: string;
    variableName?: string;
  }[];
}

interface CreateCapabilityProfileResponse {
  data: any;
}

export function useCreateCapabilityProfile() {
  const { keycloak } = useKeycloak();

  return useMutation({
    mutationFn: async (
      createCapabilityProfileData: CreateCapabilityProfileData
    ): Promise<CreateCapabilityProfileResponse> => {
      const response = await fetch(
        `${
          import.meta.env.VITE_IMPORT_ENGINE_ENDPOINT
        }/api/v1/bundles/generate_bundle/functions/create_capability_profile`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify(createCapabilityProfileData),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.message || `Request failed with status ${response.status}`);
      }

      return {
        data: data?.data,
      };
    },
  });
}
